<template>
  <div>
    <div class="container">
      <video class="video" id="cam" autoplay muted playsinline></video>
      <canvas class="canvas" id="overlay" />
    </div>
    <v-row>
      <v-col>
        <v-img :src="img1" v-if="this.img1 != null" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as faceapi from "face-api.js";

const SSD_MOBILENETV1 = "ssd_mobilenetv1";
const TINY_FACE_DETECTOR = "tiny_face_detector";

let selectedFaceDetector = SSD_MOBILENETV1;
// ssd_mobilenetv1 options
let minConfidence = 0.5;

// tiny_face_detector options
let inputSize = 512;
let scoreThreshold = 0.5;

export default {
  data() {
    return {
      stream: null,
      img1: null,
    };
  },
  methods: {
    async onPlay() {
      const videoEl = document.getElementById("cam");

      if (videoEl.paused || videoEl.ended || !this.isFaceDetectionModelLoaded())
        return setTimeout(() => this.onPlay());

      const options = this.getFaceDetectorOptions();

      //const ts = Date.now();

      const result = await faceapi.detectSingleFace(videoEl, options);

      //updateTimeStats(Date.now() - ts);

      if (result) {
        if (this.img1 == null) {
          this.img1 = this.captureVideo(videoEl);
        }
        const canvas = document.getElementById("overlay");
        const dims = faceapi.matchDimensions(canvas, videoEl, true);
        faceapi.draw.drawDetections(
          canvas,
          faceapi.resizeResults(result, dims)
        );
      }

      setTimeout(() => this.onPlay());
    },
    getFaceDetectorOptions() {
      return selectedFaceDetector === SSD_MOBILENETV1
        ? new faceapi.SsdMobilenetv1Options({ minConfidence })
        : new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold });
    },
    isFaceDetectionModelLoaded() {
      return !!this.getCurrentFaceDetectionNet().params;
    },
    getCurrentFaceDetectionNet() {
      if (selectedFaceDetector === SSD_MOBILENETV1) {
        return faceapi.nets.ssdMobilenetv1;
      }
      if (selectedFaceDetector === TINY_FACE_DETECTOR) {
        return faceapi.nets.tinyFaceDetector;
      }
    },
    captureVideo(video) {
      var canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      var canvasContext = canvas.getContext("2d");
      canvasContext.drawImage(video, 0, 0);
      return canvas.toDataURL("image/png");
    },
  },

  beforeDestroy() {
    this.stream.getTracks().forEach(function(track) {
      track.stop();
    });
  },
  mounted() {
    //let isReady = false;
    //let isRunning = false;
    // init detection options
    /*const minConfidenceFace = 0.5;
    const faceapiOptions = new faceapi.SsdMobilenetv1Options({
      minConfidenceFace,
    });
*/
    // configure face API
    faceapi.env.monkeyPatch({
      Canvas: HTMLCanvasElement,
      Image: HTMLImageElement,
      ImageData: ImageData,
      Video: HTMLVideoElement,
      createCanvasElement: () => document.createElement("canvas"),
      createImageElement: () => document.createElement("img"),
    });

    let loadNet = async () => {
      let detectionNet = faceapi.nets.ssdMobilenetv1;
      await detectionNet.load("/data/weights");
      await faceapi.loadFaceExpressionModel("/data/weights");
      return detectionNet;
    };

    let cam;
    let initCamera = async (width, height) => {
      cam = document.getElementById("cam");
      this.stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: "user",
          width: width,
          height: height,
        },
      });
      cam.srcObject = this.stream;
      return new Promise((resolve) => {
        cam.onloadedmetadata = () => {
          resolve(cam);
        };
      });
    };
    /*
    let onReady = () => {
      alert("ready");
    };
    let onExpression = (type) => {
      alert(type);
    };
*/

    loadNet()
      .then(() => {
        return initCamera(640, 480);
      })
      .then(() => {
        this.onPlay();
      });
  },
};
</script>

<style>
.container {
  margin: 0 auto;
  position: relative;
  height: 300px;
}

.video {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}

.canvas {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
